/* global google */

const sectionSelector = '.contacts-section';
const sectionCallBack = (sectionElement, query, queryAll) => {
    const { templateUri } = document.body.dataset;
    const mapElement = query('.map');

    window.initMap = function () {
        const mapStyles = [
            {
                "featureType": "all",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#FFFFFF"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#aaabb3"
                    },
                    {
                        "weight": "0.66"
                    },
                    {
                        "lightness": "16"
                    },
                    {
                        "gamma": "1.00"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#96979d"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#636468"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "saturation": "-100"
                    },
                    {
                        "lightness": "0"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#eaebf3"
                    },
                    {
                        "weight": "1.30"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#eaebf3"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#f1f3f9"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#f1f3f9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "saturation": "-61"
                    },
                    {
                        "color": "#d1d2d6"
                    }
                ]
            }
        ];
        const styledMapType = new google.maps.StyledMapType(mapStyles, { name: 'Dunes Point Capital' });
        const iconUrl = `${templateUri}/dist/images/map-pin.svg`;
        const lat = Number.parseFloat(mapElement.dataset.latitude);
        const lng = Number.parseFloat(mapElement.dataset.longitude);
        const point = { lat, lng };
        const map = new google.maps.Map(mapElement, {
            zoom: 14,
            center: point,
            mapTypeControl: false,
            streetViewControl: false,
        });

        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');

        const image = {
            url: iconUrl,
            size: new google.maps.Size(33, 49),
            // eslint-disable-next-line no-undef
            scaledSize: new google.maps.Size(33, 49),
            // The origin for this image is (0, 0).
            origin: new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new google.maps.Point(17, 25),
        };

        const marker = new google.maps.Marker({
            icon: image,
            position: point,
            map,
        });
    };

    const googleMapsAPI = document.createElement('script');
    googleMapsAPI.type = 'text/javascript';
    googleMapsAPI.defer = true;
    // googleMapsAPI.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB2n8dPuzkWOVNsajdQI_-H2LTkAwAiM8Y&callback=initMap';
    googleMapsAPI.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBHPfjJiJQnBAjhKV-_8iq-4mi36vgZoao&callback=initMap';
    document.body.appendChild(googleMapsAPI);
};

export { sectionSelector, sectionCallBack };
